module.exports = __webpack_public_path__ + "img/shopee-3PL.a014f51d.png";